import { Avatar, AvatarImage } from '@workspace/ui/components/avatar';
import { Stats } from './Stats';
import { cn } from '@workspace/ui/lib/utils';
import { UnlockButton, UserLink } from './UnlockButton';
import Image from 'next/image';

type Props = {
  authorName: string;
  authorAvatar?: string;
  createdAt: string;
  title: string;
  likes: number;
  comments: number;
  image: string;
  authorLink: string;
  id: number;
  isBitsExplore?: boolean;
  isStripeConnected?: boolean;
  stripeAccount?: string;
  creatorId: number;
  isMobileView?: boolean;
  isPartner?: boolean;
  layout?: 'grid' | 'carousel';
};

export const BitLockedCard = ({
  authorName,
  authorAvatar,
  createdAt,
  title,
  likes,
  comments,
  image,
  authorLink,
  isBitsExplore,
  isMobileView,
  layout = 'grid',
  isPartner = false,
}: Props) => {
  const isCarousel = layout === 'carousel';

  return (
    <div
      className={cn(
        'bg-bg-gray rounded-3xl p-2 hover:shadow-lg hover:bg-bg-dark-gray hover:cursor-pointer transition-all ease-in-out duration-300 mx-2',
        isCarousel &&
          'shrink-0 w-[270px] h-[280px] md:w-[330px] xl:w-[400px] md:h-[340px]',
        !isCarousel && {
          'md:w-[330px]': isBitsExplore && !isMobileView,
          'xl:w-[400px] md:h-[340px] md:mx-0 w-full h-[320px]': !isMobileView,
          'w-[270px] h-[280px] flex': isBitsExplore && isMobileView,
        }
      )}
    >
      <div className="flex flex-col h-full justify-between pb-1">
        <div className="relative w-full h-[70%] rounded-2xl overflow-hidden">
          <Image
            src={image}
            alt="Bit cover"
            className="w-full h-auto object-cover transition duration-300"
            loading="lazy"
            priority={false}
            fill
            sizes="(max-width: 768px) 100vw, 400px"
            placeholder="blur"
            blurDataURL={image}
          />
          <UnlockButton authorName={authorName} authorLink={authorLink} />
        </div>

        <div className="flex items-end gap-2 -mt-6 md:-mt-5 pl-4 md:mb-2 mb-1">
          <Avatar className="md:size-8 size-6 border-4 border-background-gray bg-background-gray">
            <AvatarImage
              src={authorAvatar || '/images/default-avatar.png'}
              alt="profile image"
            />
          </Avatar>
          <UserLink authorName={authorName} authorLink={authorLink} />
        </div>
        <h2 className="font-medium text-lg p-2 pb-0 text-black/40">{title}</h2>
        <Stats
          likes={likes}
          comments={comments}
          createdAt={createdAt}
          className="text-black/40"
        />
      </div>
    </div>
  );
};
